import { Button, ConfirmationDialog, Section, isSuccess, useOpen, useToasts } from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import { contactUpdateInquiryService } from "../../shared/api/contactUpdateInquiryService";

const DeletionRequestContentContainer = styled.div`
	display: grid;
	gap: ${({ theme }) => theme.spacing(3)};
	padding-top: ${({ theme }) => theme.spacing(10)};
	padding-bottom: ${({ theme }) => theme.spacing(10)};
`;

const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const DeletionRequestSection = () => {
	const { t } = useTranslation();
	const { open: isModalOpen, handleClose, handleOpen } = useOpen();
	const { contactId = "" } = useParams<"contactId">();
	const { id = "" } = useParams<"id">();
	const { showToast } = useToasts();
	const navigate = useNavigate();

	const createDeletionRequestForContact = useCallback(async () => {
		const result = await contactUpdateInquiryService.createDeletionRequestForContact(contactId, id);

		if (isSuccess(result)) {
			showToast({
				type: "success",
				title: t("Delete personal data"),
				body: t("Your deletion request has been submitted."),
			});
			handleClose();
			navigate("../delete-success");
		}
	}, [contactId, handleClose, id, navigate, showToast, t]);

	return (
		<>
			<Section color="background">
				<DeletionRequestContentContainer>
					<b>{t("Deletion request according to Art. 17 GDPR")}</b>
					<p>
						{t(
							"A deletion request is made by clicking on “Delete my data”. If there is no longer an active contractual relationship, all personal data and the account will be irrevocably deleted.",
						)}
					</p>
					<Actions>
						<Button onClick={handleOpen}>{t("Delete my data")}</Button>
					</Actions>
				</DeletionRequestContentContainer>
				<ConfirmationDialog
					heading={t("Warning")}
					labels={{ confirm: t("Confirm"), close: t("Close") }}
					open={isModalOpen}
					onClose={handleClose}
					action={createDeletionRequestForContact}
				>
					{t(
						"A deletion request is made by clicking on “Delete my data”. If there is no longer an active contractual relationship, all personal data and the account will be irrevocably deleted.",
					)}
				</ConfirmationDialog>
			</Section>
		</>
	);
};
